import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d153ae2a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgEmail: require('/home/hadicod/source/components/svg/email.vue').default,SvgFacebook: require('/home/hadicod/source/components/svg/facebook.vue').default,SvgInstagram: require('/home/hadicod/source/components/svg/instagram.vue').default})
